export const FEEDBACK_PROMPT_FIRST_TEST_KEY = 'feedback_first_test_completed_at'

export const FEEDBACK_PROMPT_STATUS_KEY = 'feedback_prompt_status'

export const FEEDBACK_PROMPT_SNOOZE_UNTIL_KEY = 'feedback_prompt_snooze_until'

/** Wait this long after the user's first completed test before prompting */
export const FEEDBACK_PROMPT_ELIGIBILITY_MS = 3 * 24 * 60 * 60 * 1000

/** "Ask me later" hides the prompt for this long */
export const FEEDBACK_PROMPT_SNOOZE_MS = 3 * 24 * 60 * 60 * 1000

/** Delay after test end before showing the feedback modal */
export const FEEDBACK_PROMPT_SHOW_DELAY_MS = 4000

export const FEEDBACK_PROMPT_SOURCE = 'three_day_prompt'

export enum FeedbackPromptStatus {
  SUBMITTED = 'submitted',
  DISMISSED_FOREVER = 'dismissed_forever',
  SNOOZED = 'snoozed',
}

/**
 * Set NEXT_PUBLIC_DEBUG_FEEDBACK_PROMPT=true in .env.local to preview the modal immediately.
 * Remove before shipping.
 */
export const isDebugFeedbackPromptForced = (): boolean => {
  return process.env.NEXT_PUBLIC_DEBUG_FEEDBACK_PROMPT === 'true'
}
